import * as React from 'react';

import { ICase, CaseTypes, CheckCaseId } from '../../../../share/types/case/case';
import { initialAgency } from '../../../../share/types/agency';
import _ from "lodash";
import { CasesService } from '../../../../share/services/cases';
import { CaseFormLayout } from '../layouts/CaseForm';
import { IAuthState, UserTypes } from './../../../Auth/store/types'


export interface ICaseFormProps {
  caseInfo: ICase;
  agencies: any;
  auth: IAuthState;
  setValue: (path: string, value: any) => void;
  form: (name: string, required: boolean) => any;
  disabled: boolean;
  isEditCase: boolean;
  caseIdStatus: CheckCaseId;
  setCaseIdStatus: (valid: CheckCaseId) => void
}
export class CaseForm extends React.Component<ICaseFormProps> {
  constructor(props: ICaseFormProps) {
    super(props);
    this.checkCaseId = _.debounce(this.checkCaseId, 500);
  }
  public componentDidMount() {
    if (!this.isAdmin()) {
      const agentAgency = this.props.agencies.find((agencyData) => agencyData.code === this.props.auth.agencyCode)
      this.props.form('agencyCode', true).onChange({ currentTarget: { value: agentAgency.code } })
      this.props.form('contactInformation', true).onChange({ currentTarget: { value: this.getContactInformation(agentAgency.code) } })
    }
  }
  public switchHandler(key: string) {
    const { caseInfo } = this.props
    return {
      checked: caseInfo[key],
      onChange: (e: any) => this.props.setValue(`caseInfo.${key}`, e)
    }
  }
  public onAgencyChange = (e) => {
    const contactInformation = this.getContactInformation(e.currentTarget.value);
    this.props.form('agencyCode', true).onChange(e)
    this.props.form('contactInformation', true).onChange({ currentTarget: { value: contactInformation } })
  }
  public getContactInformation(code) {
    const { agencies } = this.props;
    const agencyInformation = this.isAdmin() ? agencies.find(agency => agency.code === code) : agencies || initialAgency;
    return agencyInformation && agencyInformation.contact || '';
  }
  public onCaseIdChange = (name: string) => (e) => {
    if (name === 'agencyCode') {
      this.onAgencyChange(e);
      if (this.props.caseInfo.caseId === "") {
        return;
      }
    } else {
      e.target.value = e.target.value.toUpperCase()
      this.props.form(name, true).onChange(e)
      this.props.setCaseIdStatus(CheckCaseId.Typing)
    }
    this.checkCaseId();
  }

  public contactInfoHandler(key: string) {
    const { caseInfo, form } = this.props
    return {
      name: key,
      required: true,
      value: caseInfo[key],
      readOnly: form(key, true).disabled,
      onChange: (value: any) => {
        this.props.setValue(`caseInfo.${key}`, value)
      },
    }
  }

  public checkCaseId = _.debounce(async () => {
    const { agencyCode, caseId } = this.props.caseInfo;
    if (agencyCode && caseId.trim() !== "") {
      if (this.containsSpecialCharacters(caseId)) {
        this.props.setCaseIdStatus(CheckCaseId.InvalidCharacter);
        return;
      }
      this.props.setCaseIdStatus(CheckCaseId.Checking);
      const exists = await CasesService.exists(`${agencyCode}-${caseId}`);
      this.props.setCaseIdStatus(exists ? CheckCaseId.Invalid : CheckCaseId.Valid);
    } else {
      this.props.setCaseIdStatus(CheckCaseId.NoCheck)
    }
  }, 500);
  public containsSpecialCharacters(caseId) {
    const regex = /^[A-Z0-9\d-]+$/g;
    return !regex.test(caseId);
  }
  public isAdmin() {
    return this.props.auth.userType === UserTypes.ADMIN;
  }
  public render() {
    return <CaseFormLayout that={this} />
  }
  public getCaseStatusRender = () => {
    switch (this.props.caseIdStatus) {
      case CheckCaseId.Checking:
        return (
          <small className="form-text text-muted">Checking availability <i className="fa fa-circle-o-notch fa-spin fa-fw" /></small>
        );
      case CheckCaseId.Invalid:
        return (
          <small className="form-text text-muted">This case already exists</small>
        );
      case CheckCaseId.Valid:
        return (
          <small className="form-text text-muted">Case number available<i className="fa fa-check" /></small>
        );
      case CheckCaseId.Typing:
        return (
          <small className="form-text text-muted">...</small>
        );
      case CheckCaseId.InvalidCharacter:
        return (
          <small className="form-text text-muted">There some invalid characters</small>
        );
      default:
        return (
          <small className="form-text text-muted">Note: the agency prefix + the case # will become the case unique (Full case #)</small>
        );
    }
  }
  public getAgenciesOptions() {
    const { agencies } = this.props;
    if (this.isAdmin()) {
      return agencies.map((agency) => <option key={agency.code} value={agency.code}>{agency.name}</option>);
    }
    const agentAgency = agencies.find((agencyData) => agencyData.code === this.props.auth.agencyCode)
    return <option selected={true} key={agentAgency.code} value={agentAgency.code}>{agentAgency.name}</option>
  }

  public getCaseTypeOptions() {
    return Object.keys(CaseTypes).map(key => {
      const option = CaseTypes[key]
      return <option key={option} value={option}>{option}</option>
    })
  }
}




export default ICaseFormProps;